import React from 'react';

import FullScreen from './FullScreen';
import ToggleMenu from './ToggleMenu';

import store from '../../store/configureStore';
import { logout } from '../../store/current-user/CurrentUserActions';

import { SmartMessageBox } from '../../components/utils/actions/MessageActions';

import TenantDropdown from './TenantDropdown';
import RecentProjects from './RecentProjects';
import { domainName } from '../../config/ui';

export default class Header extends React.Component {
  userLogout() {
    SmartMessageBox(
      {
        title: 'Sign out',
        content: 'Are you sure you want to sign out?',
        buttons: '[No][Yes]',
      },
      (ButtonPressed) => {
        if (ButtonPressed === 'Yes') {
          store.dispatch(logout());
        }
        if (ButtonPressed === 'No') {
        }
      },
    );
  }

  render() {
    const { locations, logout, checks, tenants } = this.props;

    return (
      <header id="header">
        <div id="logo-group">
          <span id="logo">
            <img
              src={`assets/img/${domainName()}logo.png`} // place your logo here
              alt="SmartAdmin"
            />
          </span>
          {/* Note: The activity badge color changes when clicked and resets the number to 0
         Suggestion: You may want to set a flag when this happens to tick off all checked messages / notifications */}

          {/* <Activities /> */}
        </div>

        {!(checks.isOrganizationalClient || checks.isExternalStakeholder) && (
          <RecentProjects
            locations={locations && locations.length > 0 ? locations: []}
            user={this.props.user}
            changeLocation={this.props.changeLocation}
          />
        )}
        <div className="pull-right" /*pulled right: nav area*/>
          <ToggleMenu
            className="btn-header pull-right" /* collapse menu button */
          />

          {/* #MOBILE */}
          {/*  Top menu profile link : this shows only when top menu is active */}
          <ul
            id="mobile-profile-img"
            className="header-dropdown-list hidden-xs padding-5"
          >
            <li className="">
              <a
                className="dropdown-toggle no-margin userdropdown"
                data-toggle="dropdown"
              >
                <img
                  src="assets/img/avatars/sunny.png"
                  alt="John Doe"
                  className="online"
                />
              </a>
              <ul className="dropdown-menu pull-right">
                {/* <li>
                <a className="padding-10 padding-top-0 padding-bottom-0"><i
                  className="fa fa-cog"/> Setting</a>
              </li> */}
                {/* <li className="divider"/> */}
                <li>
                  <a
                    href="#/profile"
                    className="padding-10 padding-top-5 padding-bottom-5"
                  >
                    {' '}
                    <i className="fa fa-user" /> <u>P</u>rofile
                  </a>
                </li>
                {/* <li className="divider"/>
              <li>
                <a className="padding-10 padding-top-0 padding-bottom-0"
                   data-action="toggleShortcut"><i className="fa fa-arrow-down"/> <u>S</u>hortcut</a>
              </li>
              <li className="divider"/>
              <li>
                <a className="padding-10 padding-top-0 padding-bottom-0"
                   data-action="launchFullscreen"><i className="fa fa-arrows-alt"/> Full
                  <u>S</u>creen</a>
              </li> */}
                <li className="divider" />
                <li>
                  <a
                    href="#/login"
                    onClick={logout}
                    className="padding-10 padding-top-5 padding-bottom-5"
                    data-action="userLogout"
                  >
                    <i className="fa fa-sign-out fa-lg" />{' '}
                    <strong>
                      <u>L</u>ogout
                    </strong>
                  </a>
                </li>
              </ul>
            </li>
          </ul>

          {/* logout button */}
          <div id="logout" className="btn-header transparent pull-right">
            <span>
              {' '}
              <a
                href="#/login"
                title="Sign Out"
                onClick={this.userLogout}
                data-logout-msg="You can improve your security further after logging out by closing this opened browser"
              >
                <i className="fa fa-sign-out" />
              </a>{' '}
            </span>
          </div>

          {/* search mobile button (this is hidden till mobile view port) */}
          {/* <SearchMobile className="btn-header transparent pull-right"/> */}

          {/* input: search field */}
          {/* <form action="#/misc/search.html" className="header-search pull-right">
          <input id="search-fld" type="text" name="param" placeholder="Find reports and more"
                 data-autocomplete='[
					"ActionScript",
					"AppleScript",
					"Asp",
					"BASIC",
					"C",
					"C++",
					"Clojure",
					"COBOL",
					"ColdFusion",
					"Erlang",
					"Fortran",
					"Groovy",
					"Haskell",
					"Java",
					"JavaScript",
					"Lisp",
					"Perl",
					"PHP",
					"Python",
					"Ruby",
					"Scala",
					"Scheme"]'/>
          <button type="submit">
            <i className="fa fa-search"/>
          </button>
          <a href="$" id="cancel-search-js" title="Cancel Search"><i className="fa fa-times"/></a>
        </form> */}

          <FullScreen className="btn-header transparent pull-right" />

          <div id="newTask" className="btn-header transparent pull-right">
            <span>
              <a href="#/task-manager/task/0" title="New Task">
                <i className="fa fa-tablet" />
              </a>
            </span>
          </div>

          {/* <SpeechButton className="btn-header transparent pull-right hidden-sm hidden-xs" /> */}

          {/* multiple lang dropdown : find all flags in the flags page */}
          {/* <LanguageSelector /> */}
        </div>
        {/* end pulled right: nav area */}
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Header.js